import { useState, useEffect, forwardRef } from 'react';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  ListItemText
} from '@mui/material';

interface WorkModelTypeMultiSelectProps {
  value: string[] | [],
  onChange: (e: any) => void,
}

const workModelOptions = [
  { label: 'Permanent WFH', value: 'PERMANENT_WFH' },
  { label: 'Hybrid', value: 'HYBRID' },
  { label: 'In Office', value: 'IN_OFFICE' }
];

const WorkModelTypeMultiSelect = forwardRef((props: WorkModelTypeMultiSelectProps, _ref) => {
  const [types] = useState(['Permanent_WFH', 'Hybrid', 'In Office']);
  const [selectedTypes, setSelectedTypes] = useState<string[]>([]);

  useEffect(() => {
    if(props?.value){
      setSelectedTypes(props?.value);
    }
  }, [props?.value]);

  const handleChange = (event: any) => {
    const {
      target: { value }
    } = event;
    setSelectedTypes(typeof value === 'string' ? value.split(',') : value);
    props.onChange(event);
  };

  return (
    <FormControl fullWidth>
      <InputLabel
        style={{
          fontSize: '12px'
        }}
      >
        Work Model
      </InputLabel>
      <Select
        id="filter-resource"
        sx={{ mt: 1 }}
        style={{
          fontSize: '12px',
          height: '2rem'
        }}
        multiple
        size="small"
        value={selectedTypes}
        renderValue={(selected) => selected.map((val) => {
          const option = workModelOptions.find(option => option.value === val);
          return option ? option.label : val;
        }).join(', ')}
        onChange={handleChange}
      >
        {workModelOptions.map((option, i) => (
          <MenuItem key={i} value={option.value}>
            <Checkbox checked={selectedTypes.indexOf(option.value) > -1} />
            <ListItemText primary={option.label} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
});

export default WorkModelTypeMultiSelect;
